// ================================================================
//  Global API Base URL
//  Change this ONE value when switching environments.
//
//  Local XAMPP :  'http://localhost/striglia'
//  Dev Sandbox :  'http://psmdev.eastus.cloudapp.azure.com:4000'
//  QA           :  'http://qa.striglia.net'
//  Production   :  'https://striglia.net'
//  Same-origin  :  ''  (empty — API is on the same host as the app)
// ================================================================

//const API_BASE_URL = 'https://mk.com/striglia';
const API_BASE_URL = '';

export default API_BASE_URL;
